const escapeHtml = (text) => {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const sanitizeHtml = (input) => {
  if (input == null || input === '') return '';
  const html = String(input);

  if (!html.includes('<')) {
    return escapeHtml(html).replace(/\n/g, '<br />');
  }

  const allowed = new Set([
    'BODY',
    'B', 'STRONG',
    'I', 'EM',
    'U',
    'S', 'STRIKE', 'DEL',
    'BR',
    'P', 'DIV', 'SPAN',
    'UL', 'OL', 'LI',
    'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
    'BLOCKQUOTE',
    'PRE', 'CODE',
    'A',
    'IMG'
  ]);

  const isSafeUrl = (url, type) => {
    const u = String(url || '').trim();
    if (!u) return false;
    const lower = u.toLowerCase();
    const scriptSuffix = 'script:';
    const jsProtocol = `java${scriptSuffix}`;
    const vbsProtocol = `vb${scriptSuffix}`;
    if (lower.startsWith(jsProtocol) || lower.startsWith(vbsProtocol)) return false;

    if (type === 'href') {
      return (
        lower.startsWith('http://') ||
        lower.startsWith('https://') ||
        lower.startsWith('mailto:') ||
        lower.startsWith('#') ||
        lower.startsWith('/')
      );
    }

    if (type === 'src') {
      if (lower.startsWith('data:')) {
        return /^data:image\/(png|jpe?g|gif|webp);/i.test(u);
      }
      return lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('/');
    }

    return false;
  };

  let doc;
  try {
    const parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');
  } catch (e) {
    return escapeHtml(html).replace(/\n/g, '<br />');
  }

  // Defensive: ensure doc.body exists
  if (!doc || !doc.body) {
    return escapeHtml(html).replace(/\n/g, '<br />');
  }

  const sanitizeNode = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node;
      if (!allowed.has(el.tagName)) {
        const parent = el.parentNode;
        if (!parent) return;
        while (el.firstChild) parent.insertBefore(el.firstChild, el);
        parent.removeChild(el);
        return;
      }

      const attrs = Array.from(el.attributes || []);

      // Strip everything except safe minimal attrs for links/images
      if (el.tagName === 'A') {
        const href = el.getAttribute('href');
        attrs.forEach((a) => el.removeAttribute(a.name));
        if (href && isSafeUrl(href, 'href')) {
          el.setAttribute('href', href);
          el.setAttribute('target', '_blank');
          el.setAttribute('rel', 'noopener noreferrer');
        }
      } else if (el.tagName === 'IMG') {
        const src = el.getAttribute('src');
        const alt = el.getAttribute('alt');
        attrs.forEach((a) => el.removeAttribute(a.name));
        if (src && isSafeUrl(src, 'src')) {
          el.setAttribute('src', src);
          if (alt) el.setAttribute('alt', alt);
        } else {
          // Remove unsafe images
          const parent = el.parentNode;
          if (parent) parent.removeChild(el);
          return;
        }
      } else {
        attrs.forEach((a) => el.removeAttribute(a.name));
      }
    }

    const children = Array.from(node.childNodes || []);
    children.forEach((c) => sanitizeNode(c));
  };

  sanitizeNode(doc.body);
  return doc.body.innerHTML || '';
};

export default sanitizeHtml;
